export const PLAY_TRACK = 'player/PLAY_TRACK'
export const PAUSE_TRACK = 'player/PAUSE_TRACK'
export const SHOW_PLAYER = 'player/SHOW_PLAYER'
export const HIDE_PLAYER = 'player/HIDE_PLAYER'
export const ADD_TRACK_TO_PLAYLIST = 'player/ADD_TRACK_TO_PLAYLIST'
export const PLAY_NEXT_TRACK = 'player/PLAY_NEXT_TRACK'
export const PLAY_PREV_TRACK = 'player/PLAY_PREV_TRACK'
export const VOLUME_CHANGED = 'player/VOLUME_CHANGED'
export const MUTE_PLAYER = 'player/MUTE_PLAYER'
